export const currentOriginalSlug = $state<{ slug: string | null }>({ slug: null });
